module.exports = __webpack_public_path__ + "media/seher_1.2b.70a2d48c.mp3";